import React from "react";
import { Panel, useReactFlow } from "@xyflow/react";
import {
  Button,
  ButtonGroup,
  Maximize01,
  Plus,
  Trash01,
  ZoomIn,
  ZoomOut,
} from "@opendate-app/setlist";

import { useCustomCampaignShowContext } from "./CustomCampaignShowContainer";

const toolbarStyle = {
  display: "flex",
  alignItems: "center",
  gap: 8,
  padding: 8,
  borderRadius: 12,
  border: "1px solid var(--sl-border-secondary)",
  backgroundColor: "var(--sl-bg-primary)",
  boxShadow: "var(--sl-shadow-sm)",
};

const spacerStyle = {
  width: 1,
  height: 24,
  backgroundColor: "var(--sl-border-secondary)",
};

export default ({ handleDeleteNode }) => {
  const {
    building,
    setBuilding,
    selectedNode,
    setSelectedNode,
    customCampaign,
    flowNodes,
  } = useCustomCampaignShowContext();

  const { zoomIn, zoomOut, fitView } = useReactFlow();

  const handleBuildClicked = () => {
    if (selectedNode) {
      setBuilding(true);
      setSelectedNode(null);
    } else {
      setBuilding(!building);
    }
  };

  const handleDeleteNodeClicked = () => {
    if (selectedNode && handleDeleteNode) {
      handleDeleteNode(selectedNode.internal_id);
    }
  };

  const showDeleteButton = selectedNode
    && selectedNode.type !== "WorkflowNodes::TriggerNode"
    && selectedNode.type !== "WorkflowNodes::ExitNode";

  return (
    <Panel position="bottom-center">
      <div style={toolbarStyle}>
        {customCampaign.trigger_finalized ? (
          <Button
            variant={building ? "secondary-color" : "secondary"}
            icon={Plus}
            aria-pressed={building}
            onClick={handleBuildClicked}
          >
            Build
          </Button>
        ) : null}
        {showDeleteButton ? (
          <>
            <div style={spacerStyle} />
            <Button variant="destructive" icon={Trash01} onClick={handleDeleteNodeClicked}>
              Delete
            </Button>
            <div style={spacerStyle} />
          </>
        ) : null}
        <ButtonGroup
          aria-label="Canvas zoom"
          items={[
            { icon: ZoomOut, "aria-label": "Zoom out", onClick: () => zoomOut() },
            { icon: ZoomIn, "aria-label": "Zoom in", onClick: () => zoomIn() },
            { icon: Maximize01, "aria-label": "Fit to screen", onClick: () => fitView({ nodes: flowNodes, duration: 750 }) },
          ]}
        />
      </div>
    </Panel>
  );
};
